import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form"
import Select from 'react-select'

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import { GetTemplateType, TemplateForm } from "./TemplateForm";


export default function TemplateEdit({}) {

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const media_url = useContext(MEDIA_URL);
  const [template, setTemplate] = useState(Object());
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();
  
  let { templateId } = useParams();
  templateId = Number(templateId);

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: {},
  });


  const onSubmit = (data) => {
    console.log(data);

    // refactor this. Use OnChange function for Select
    let typeValue = data.type.value;
    data.type = typeValue;
    let groupIds = data.group.map(x => (x.value));
    data.group = groupIds;

    axios_api.put(api_url + `/manage_template/` + templateId, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("Template updated");
        navigate("/template/" + templateId);
        //navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );

  }

  // console.log(watch("example")) // watch input value by passing the name of it

  React.useEffect(() => {

      let template = axios_api.get(api_url + '/manage_template/' + templateId, {
        headers: {"Authorization": token},
      });
  
      template.then(
        (result) => {
          let apiReturnedTemplate = result.data;
          setTemplate(apiReturnedTemplate);
          //console.log(apiReturnedTemplate);

          let formData = structuredClone(result.data);
          formData.type = {value: result.data.type, label: GetTemplateType(result.data.type)};
          formData.group = result.data.group.map((x) => ({value: x.id, label: x.name}));
          reset(formData);

          let groups = axios_api.get(api_url + '/groups', {
            headers: {"Authorization": token},
          });

          groups.then(
            (result) => {
              let apiReturnedGroups = result.data;
              setGroups(apiReturnedGroups);
  
            },
            (error) => {
              console.log(error);
              setGroups([]);
            }
          );
        },
        (error) => {
          console.log(error);
          //setTemplate([]);
        }
      );
  }, []);

  let nameDisabled = true;

  (template.name !== undefined && template.name !== 'стандартный') ?  nameDisabled = false :  nameDisabled = true


  return (
    <>
      <h3 className="m-3">Изменить шаблон</h3>
      <TemplateForm
        groups={groups}
        control={control}
        register={register}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        templateFile={template.template_file}
        signFile={template.signature_file}
        nameFieldDisabled={nameDisabled}
      />
    </>
  );
}